/**
 * @file app 回调
 * @author liudy
 * @see 参考screen
 */

import umuWebview from '@umu/umu-webview';
import { SendMsgType } from '@umu/umu-types';

export interface ISendMsgToWebData {
    type: SendMsgType;
    data?: {
        active: string;
        actionType?: number;
        info?: { [prop: string]: any };
    };
    [key: string]: unknown;
}

export interface IInitMsgToWebData {
    page: string; // 页面名称
    route?: string; // 前端路由
    info?: { [prop: string]: any };
}

type channelParam = (type: SendMsgType, callback: () => void, data?: ISendMsgToWebData) => void;
export function initWebview(cb: channelParam) {
    umuWebview.registerHandler('sendMsgToWeb', (data: ISendMsgToWebData, callback) => {
        console.log('来自 native 的 data:' + JSON.stringify(data));

        if (cb) {
            cb(data.type, callback, data);
        }
    });
}
